import $ from 'jquery'

const Counter = (() => {
  const init = () => {
    $(".c-dashboard__countdown").each(function() {
      $(this).countdown($(this).attr("data-deadline"), function(event){
        $(this).html(event.strftime(''
          + '<span>%w</span> week%!w '
          + '<span>%d</span> day%!d '
          + '<br>'
          + '<span>%H</span> hr '
          + '<span>%M</span> min '
          + '<span>%S</span> sec'
        ))
      })
    })


    $(".c-challenge__countdown").countdown($(".c-challenge__countdown").attr("data-countdown"), function(event){
      $(".c-challenge__countdown").html(event.strftime(''
          + '<span>%w</span> week%!w '
          + '<span>%d</span> day%!d '
          + '<span>%H</span> hr '
          + '<span>%M</span> min '
          + '<span>%S</span> sec'
        ))
    })
  }

  return {
    init
  }
})()

export default Counter


// WEBPACK FOOTER //
// app/javascript/scripts/components/Counter.js